import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { getStorefrontApiConfig } from '../helpers/config';
const params = new URLSearchParams(window.location.search);
const shopifyHandle = params.get('shopify-handle');
const storefrontConfig = getStorefrontApiConfig();
const storefrontClient = new ApolloClient({
    // use env variable to replace the uri shopify name
    uri: `https://${storefrontConfig.storeName}.myshopify.com/api/2025-01/graphql.json`,
    cache: new InMemoryCache(),
    headers: {
        'X-Shopify-Storefront-Access-Token':
            `${storefrontConfig.accessToken}`,
    },
});

// add function for fetching vending machine meta object
const GET_VENDING_MACHINE_META_OBJECT = gql`
# query GetVendingMachineMetaobject ($handleInput: MetaobjectHandleInput!){
#     metaobject(handle: $handleInput) {
query GetVendingMachineMetaObject ($id: ID!){
    metaobject(id: $id) {
            id
            handle
            fields {
                key
                type
                value 
                references (first: 20) { 
                    edges {
                        node{
                            # for product variant
                            ... on ProductVariant {
                                id
                                title
                                sku
                                price {
                                    amount
                                    currencyCode
                                }
                                availableForSale
                                selectedOptions {
                                    name
                                    value
                                }
                                quantityAvailable
                                product {
                                    id
                                    title
                                    description
                                    images(first: 10) {
                                        edges {
                                            node {
                                                originalSrc
                                                altText
                                            }
                                        }
                                    }
                                    metafields (identifiers: [{namespace: "custom", key: "dashboard_product_id"}]) {
                                        namespace
                                        key
                                        value
                                    }
                                    featuredImage {
                                        originalSrc
                                        altText
                                    }
                                }
                            }
                            # for banner_image
                            ... on Metaobject {
                                id 
                                handle
                                type
                                fields {
                                    key
                                    type
                                    value
                                    reference{
                                        ... on MediaImage {
                                            id
                                            image {
                                                url
                                                height
                                            }
                                            mediaContentType
                                        }
                                    }
                                }
                            } 
                        }
                    }
                }
            }
        }
    }
`;


const GET_PRODUCTS_BY_VARIANT_TYPE = gql`
    query GetProductsByVariantType($searchQuery: String!) {
        products(first: 100, query: $searchQuery) {
            edges {
                node {
                    id
                    title
                    images(first: 1) {
                        edges {
                            node {
                                originalSrc
                                altText
                            }
                        }
                    }
                    variants(first: 100) {
                        edges {
                            node {
                                id
                                title
                                priceV2 {
                                    amount
                                    currencyCode
                                }
                                sku
                                price {
                                    amount
                                    currencyCode
                                }
                                availableForSale
                                selectedOptions {
                                    name
                                    value
                                }
                                quantityAvailable
                            }
                        }
                    }
                }
            }
        }
    }
`;

function getVendingMachineMetaObject() {
    return storefrontClient.query({
        query: GET_VENDING_MACHINE_META_OBJECT,
        variables: {
            // handleInput: {
            //     type: 'vending_machine',
            //     // handle: "vending-machine-m7d1fozh",
            //     // handle: process.env.REACT_APP_SHOPIFY_META_OBJECT_HANDLE_ID
            //     handle: storefrontConfig.shopifyHandle
            // },
            id: `gid://shopify/Metaobject/${storefrontConfig.gidNo}`,
        },
        fetchPolicy: 'network-only',
    }).then((result) => {
        return result;
    }).catch((error) => {
        console.error('Error:', error);
        throw error;
    });
}

function getProductsByVariantType(searchQuery) {
    return storefrontClient.query({
        query: GET_PRODUCTS_BY_VARIANT_TYPE,
        variables: { searchQuery },
        fetchPolicy: 'network-only',
    }).then((result) => {
        return result;
    }).catch((error) => {
        console.error('Error:', error);
        throw error;
    });
}

function refetchProductsByVariantType(searchQuery) {
    return storefrontClient.refetchQueries({
        include: "all",
        onQueryUpdated(observableQuery) {
            // Logging and/or debugger breakpoints can be useful in development to
            // understand what client.refetchQueries is doing.
            console.log(`Examining ObservableQuery ${observableQuery.queryName}`);
            debugger;

            // Proceed with the default refetching behavior, as if onQueryUpdated
            // was not provided.
            return true;
        },

    });
}

function fetchLocation() {
    return storefrontClient.query({
        query: gql`
        query {
            locations(first: 1, near: {
                latitude: 0.0,
                longitude: 0.0
            }) {
                edges {
                    node {
                        id
                    }
                }
            }
        }
        `,

    }).then((result) => {
        return result;
    }).catch((error) => {
        console.error('Error:', error);
        throw error;
    });
}
export {
    getProductsByVariantType,
    refetchProductsByVariantType,
    getVendingMachineMetaObject,
    fetchLocation,
};